// patient static 
// url ids= doctor, regid, appoiment id, 
// match mobile number 
// 
// 

import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OtpVerifyDialogComponent } from '..';
import { environment } from '../../../../environments/environment';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { VideoAppointmentsData } from '../../../@core/interfaces/patient-services/videoAppointment';
import { UserStore } from '../../../@core/stores/user.store';
import { InitUserService } from '../../../@theme/services/init-user.service';

@Component({
  selector: 'ngx-patient-videocall-login',
  templateUrl: './patient-videocall-login.component.html',
  styleUrls: ['./patient-videocall-login.component.css']
})
export class PatientVideocallLoginComponent implements OnInit {

  private tenandId = String(environment.tenantId);
  private branchId = String(environment.branchId.toLowerCase());
  protected readonly unsubscribe$ = new Subject<void>();
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  optVerfication:boolean=false;
  phoneNum:any;
  otpId:any;
  smsdto={"variables":[],"template_id":"","to":"","service":"T"};

  constructor(private route: ActivatedRoute,
    private router: Router,
    protected userStore: UserStore,
    protected initUserService: InitUserService,
    protected cd: ChangeDetectorRef, protected patRegSrvc: PatientRegistrationData,
    private VideoAppointmentsservice:VideoAppointmentsData,
    ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      console.log("Params = ", params); 
      if(params['Id']!=null){
        if(params['roomID']!=null){
          this.checkCall(params);
        }
      }
    });
  }
  checkCall(params){
    var id=String(params['Id']);
    var regId=String(params['regId']);
    var docId=String(params['docId']);
  
    this.tenandId="7ba36cfc-c81b-49a1-f304-08d8e7a574ea";
    this.branchId="ca6bc985-49bb-4c50-1a0f-08d8e7a59bf9";
    docId="c857da74-7623-44e1-389e-08d8e83bfad0";
    regId="fb197da0-7d44-4cdd-61a6-08d8e83acabf";
    var apiUrl="https://ezoviondev.azurewebsites.net/api";
 
console.log(this.tenandId,this.branchId,regId,docId);

    this.VideoAppointmentsservice.list(`${apiUrl}/videoAppointments/${this.tenandId}/${this.branchId}/${regId}/${docId}/GetAppointmentsByRegPhysician`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      let responseList = (data);
      console.log("load video appoinment data = ",data);
      for(var i=0;i<data.length;i++){ 
        if(data[i].appointmentId==id){
          console.log("DATA = ", data[i])
          this.optVerfication=true;

          this.phoneNum='8778733766'; //static
          window.localStorage.setItem("mobileNO",this.phoneNum);
          this.sendOtp(this.phoneNum);

          window.localStorage.setItem("MeetingDetailes_",JSON.stringify(data[i]));
          // this.router.navigate([`/pages/patientservices/patient-join-call/${data[i].id}/${data[i].doctor.id}`]);

        }else{
          // this.onCancel()
        }
      }
    }, (error) => {
      console.log("error =",error);
      
    }, () => {
    });
  }
  get apiUrl(): string {
    return environment.apiUrl;
  }

  onOtpDiaClose(data: any): void { 
    console.log(" 1 .....portal......otp status.......",data);
    if (data == null)
    {
        this.onCancel();
    }
    else if (data.otpStatus == "approved" || data.otpStatus == "success") {
      console.log("2 .....portal......otp status.......",data);
      this.initUserService.initCurrentUser().subscribe();

      this.onJoinCall();
    }
  }
onJoinCall(){
  var data=JSON.parse(window.localStorage.getItem("MeetingDetailes_"));
  window.localStorage.setItem("MeetingDetailes",JSON.stringify(data));

  var user={ "fullName": window.localStorage.getItem("mobileNO"),"password": "12345", "rememberMe": "","tenantId": environment.tenantId }
  // this.userStore.setUser(user);
  window.localStorage.removeItem("mobileNO");
  localStorage.setItem("isSuperUser",null);
  localStorage.setItem("tenantId",environment.tenantId);
  localStorage.setItem("branchId",environment.branchId);
  localStorage.setItem('userId',null);
  localStorage.setItem('userType',null);
  localStorage.setItem('loginuser',"patientlogin");
  localStorage.setItem('physicianId',(0).toString());
  localStorage.setItem('employeeId',(0).toString()); 
  this.router.navigate([`/pages/patientservices/patient-join-call/${data.id}/${data.doctor.id}`]);

}
  onCancel(){
    window.localStorage.clear();
    this.router.navigate([`/auth/login`]);
  }
  sendOtp(mobilNo) { 
    var mobileNumber= mobilNo;
    this.patRegSrvc.sendMessageOtp("communication/" + environment.tenantId + '/' + environment.tenantId + '/sendotp/' + mobileNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.otpId = data;
      console.log("sendmessage...........", data); 
    }, (error) => { 
    }, () => { 
      this.otpVerifyInstance.fromPatientPortal(mobileNumber,environment.tenantId,this.otpId, "PatientPortal")
      this.cd.detectChanges(); 
      console.log("otp sent..ggg.........", this.otpVerifyInstance);
    });
   
  }
}
